import { render } from "./MyTeam.vue?vue&type=template&id=33b852f1&scoped=true"
import script from "./MyTeam.vue?vue&type=script&lang=js"
export * from "./MyTeam.vue?vue&type=script&lang=js"

import "./MyTeam.vue?vue&type=style&index=0&id=33b852f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b852f1"]])

export default __exports__